import { Component, ViewChild, OnInit, Input } from '@angular/core'
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid'

@Component({
    selector: 'enrollment-JQGrid',
    templateUrl: `enrollment-jq-datagrid.component.html`
})
export class EnrollmentJQGridData implements OnInit {
    @ViewChild('gridReference', { static: true }) myGrid: jqxGridComponent

    jqx: any
    @Input() data: any = []

    source: any = {
        datafields: [
            { name: 'FirstName', type: 'string' },
            { name: 'LastName', type: 'string' },
            { name: 'AgentID', type: 'string' },
            { name: 'DOB', type: 'string' },
            { name: 'HIC', type: 'string' },
            { name: 'CUID', type: 'string' },
            { name: 'Confirmation Number', type: 'number' },
            { name: 'ApplicationDate', type: 'string' },
            { name: 'EffectiveDate', type: 'string' },
            { name: 'PlanType', type: 'string' },
            { name: 'PlanYear', type: 'string' },
            { name: 'Status', type: 'string' }
        ],
        dataType: 'json',
        id: 'EnrollmentJQGridID',
        localData: this.data
    }

    dataAdapter: any = new jqx.dataAdapter(this.source)

    columns: any[] = [
        { text: 'First Name', datafield: 'FirstName', width: 120 },
        { text: 'Last Name', datafield: 'LastName', width: 120 },
        { text: 'Agent Id', datafield: 'AgentID', width: 180 },
        { text: 'Date of Birth', datafield: 'DOB', width: 80, cellsalign: 'right' },
        { text: 'HIC', datafield: 'HIC', width: 90, cellsalign: 'right', cellsformat: 'c2' },
        { text: 'CUID', datafield: 'CUID', cellsalign: 'right', cellsformat: 'c2' },
        { text: 'Application Date', datafield: 'ApplicationDate', cellsalign: 'right', cellsformat: 'c2' },
        { text: 'Effective Date', datafield: 'EffectiveDate', cellsalign: 'right', cellsformat: 'c2' },
        { text: 'Plan Type', datafield: 'PlanType', cellsalign: 'right', cellsformat: 'c2' },
        { text: 'Plan Year', datafield: 'PlanYear', cellsalign: 'right', cellsformat: 'c2' },
        { text: 'Status', datafield: 'Status', cellsalign: 'right', cellsformat: 'c2' }
    ]

    constructor() {}

    ngOnInit(): void {}
}

// updateLog(observableArray: any): void {
//    let rows = ''
//    for (let i = 0; i < observableArray.length; i++) {
//        rows += observableArray.toJSON(['SecureMessageThreadId', 'UserProfileName', 'CategoryName',
//            'SecureMessageSubject', 'SecureMessageRead', 'SecureMessageTS'], observableArray[i])
//        rows += '<br/>'
//    }
//    // let container = document.getElementById('log');
//    this.log.nativeElement.innerHTML = rows
// }
